export * from "./ips-bloqueados.component";
